import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationService } from '@app/core/services/navigation.service';
import { TicketService } from '@app/core/services/ticket.service';
import { TicketStatus } from '@app/shared/models/enums/ticket-status';
import { Ticket } from '@app/shared/models/ticket.model';

@Component({
  selector: 'app-service-ticket-tasks',
  templateUrl: './service-ticket-tasks.component.html',
  styleUrls: ['./service-ticket-tasks.component.scss']
})
export class ServiceTicketTasksComponent implements OnInit {
  loading = false;
  ticketId: number;
  ticket = new Ticket();
  ticketTools = [];

  constructor(private route: ActivatedRoute, private ticketService: TicketService, private router: Router,
    private navigationService: NavigationService) { }

  ngOnInit() {
    this.loading = true;
    this.route.parent.params.subscribe(
        (params) => {
            this.ticketId = +params['id'];
            this.getTicketDetails(this.ticketId);
        }
    );
  }

  getTicketDetails(ticketId: number) {
    this.ticketService.getTicketById(ticketId).subscribe(
        (data: Ticket) => {
            this.ticket = data;
            this.ticketTools = this.ticket.ticketTools;
            this.loading = false;
        },
        (error) => {
            this.loading = false;
        }
    );
  }

  onSelectActivity(activity: any) {
    this.router.navigate([`../activities/${activity.operationId}/details`], {relativeTo: this.route});
    this.navigationService.addToHistory(this.router.url);
  }

  canSelect(operation: any) {
      return this.ticket.status !== TicketStatus.WAITING_FOR_TOOLS;
  }
}
